import { tokenService } from '@/services/TokenService';
import { createConsumer } from '@rails/actioncable';
import EventBus from '@/EventBus';
import { storeService } from '@/services/StoreService';

class WebsocketService {
  ws: any = null;
  currentSubscription: any = null;
  currentWorkspaceId: any = 0;
  baseUrl = process.env.VUE_APP_WEBSOCKET_URL;
  isConnected = false;

  connect() {
    const token = tokenService.getToken();
    if (!this.ws) {
      this.ws = createConsumer(`${this.baseUrl || '/websocket'}?token=${token}&url=${this.baseUrl}`);
      this.ws.connect();
      // EventBus.$emit('show-info', `Websocket connecting...`);
    }
  }

  translate(key: string) {
    return (window as any).VueGlobal.$i18n.t(key);
  }

  wsTranslate(key: string) {
    return `${this.translate(key)}`;
  }

  subscribe(channel: string, workspaceId: any) {
    if (parseInt(this.currentWorkspaceId, 10) === parseInt(workspaceId, 10)) {
      return;
    } else if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
    }
    this.currentWorkspaceId = workspaceId;
    this.connect();
    const subscription = {
      channel: channel,
      workspace_id: workspaceId,
    };
    this.currentSubscription = this.ws.subscriptions.create(subscription, {
      connected: () => {
        this.isConnected = true;
        // EventBus.$emit('show-info', `Websocket subscribed to: ${channel} ${workspaceId}`);
      },
      disconnected: () => {
        this.isConnected = false;
        // EventBus.$emit('show-info', `Websocket disconnected: ${channel} ${workspaceId}`);
      },
      rejected: () => {
        this.isConnected = false;
        // EventBus.$emit('show-info', `Websocket rejected: ${channel} ${workspaceId}`);
      },
      received: (data: any) => {
        this.handleEvent(data.event_name, data.payload);
      },
    });

    (window as any).fakeWebsocketMessage = (data: any) => {
      this.handleEvent(data.message.event_name, data.message.payload);
    };
  }

  handleEvent(name: string, payload: any) {
    switch (name) {
      case 'virtual_machine_create_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.create.started'));
        // storeService.addVirtualMachine(payload);
        storeService.getVirtualMachineListForCurrentWorkspace(true);
        break;
      case 'virtual_machine_create_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.create.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_create_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.create.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.update.succeeded'));
        storeService.updateVirtualMachineData(payload);
        break;
      case 'dm_reservation_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.dm.update.succeeded'));
        storeService.updateDedicatedMachineData(payload);
        break;
      case 'virtual_machine_power_on_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.powerOn.started'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_power_on_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.powerOn.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_power_on_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.powerOn.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_power_off_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.powerOff.started'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_power_off_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.powerOff.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_power_off_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.powerOff.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_suspend_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.suspend.started'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_suspend_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.suspend.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_suspend_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.suspend.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_restart_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.restart.started'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_restart_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.restart.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_restart_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.restart.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_cpu_limit_update_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.restart.started'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_cpu_limit_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.restart.succeeded'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_cpu_limit_update_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.restart.failed'));
        storeService.updateVirtualMachineState(payload);
        break;
      case 'virtual_machine_destroy_started':
        setTimeout(() => {
          EventBus.$emit('show-success', this.wsTranslate('ws.vm.destroy.succeeded'));
        }, 2000);
        storeService.destroyVirtualMachine(payload);
        EventBus.$emit('virtual-machine-destroyed', payload.id);
        break;
      case 'dm_reservation_requested':
        EventBus.$emit('show-info', this.wsTranslate('ws.dm.reserve.requested'));
        storeService.getDedicatedMachineList(true);
        break;
      case 'dm_task_started':
        EventBus.$emit('show-info', this.wsTranslate(`ws.dm.${payload.task_name}.started`));
        storeService.updateDedicatedMachineState({ id: payload.reservation.id, state: payload.reservation.state });
        break;
      case 'dm_task_succeeded':
        EventBus.$emit('show-success', this.wsTranslate(`ws.dm.${payload.task_name}.succeeded`));
        storeService.updateDedicatedMachineState({ id: payload.reservation.id, state: payload.reservation.state });
        break;
      case 'dm_task_failed':
        EventBus.$emit('show-fail', this.wsTranslate(`ws.dm.${payload.task_name}.failed`));
        storeService.updateDedicatedMachineState({ id: payload.reservation.id, state: payload.reservation.state });
        break;
      case 'dm_state_changed':
        storeService.updateDedicatedMachineState({ id: payload.reservation.id, state: payload.reservation.state });
        break;
      case 'dm_resignation_requested':
        EventBus.$emit('show-info', this.wsTranslate('ws.dm.resign.requested'));
        storeService.destroyDedicatedMachine(payload);
        break;
      case 'dm_reservation_failed':
        payload.reservation.dm_nics.map((nic: any) => {
          storeService.updateDedicatedNic(nic);
        });
        break;
      case 'dm_reservation_succeeded':
        payload.reservation.dm_nics.map((nic: any) => {
          storeService.updateDedicatedNic(nic);
        });
        break;
      case 'workspace_update_name_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.workspace.update_name.succeeded'));
        storeService.updateWorkspaceName(payload);
        break;
      case 'usage_limit_update_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.usage_limit.update.succeeded'));
        storeService.getLimits(payload);
        break;
      case 'current_usage_changed':
        EventBus.$emit('show-info', this.wsTranslate('ws.current_usage.changed'));
        storeService.getCurrentUsage(payload);
        break;
      case 'user_update_role_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.users.roleUpdate'));
        storeService.updateWorkspaceUsers();
        break;
      case 'user_destroy_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.users.destroy'));
        storeService.updateWorkspaceUsers();
        break;
      case 'user_update_username_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.users.usernameUpdate'));
        storeService.updateWorkspaceUsers();
        break;
      case 'user_invitation_create_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.users.invitation.create'));
        storeService.updateWorkspaceUsers();
        break;
      case 'user_invitation_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.workspace.users.invitation.destroy'));
        storeService.updateWorkspaceUsers();
        break;
      case 'public_ip_address_reserve_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.public_ip_address.create.started'));
        storeService.getPublicAddresses();
        break;
      case 'public_ip_address_reserve_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.public_ip_address.create.succeeded'));
        storeService.getPublicAddresses();
        break;
      case 'public_ip_address_reserve_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.public_ip_address.create.failed'));
        storeService.getPublicAddresses();
        break;
      case 'public_ip_address_resign_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.public_ip_address.destroy.started'));
        storeService.getPublicAddresses();
        break;
      case 'public_ip_address_resign_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.public_ip_address.destroy.succeeded'));
        storeService.getPublicAddresses();
        break;
      case 'public_ip_address_resign_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.public_ip_address.destroy.failed'));
        storeService.getPublicAddresses();
        break;
      case 'private_network_create_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.private_network.create.started'));
        // storeService.addPrivateNetwork(payload);
        storeService.getPrivateNerworksListForCurrentWorkspace(true);
        break;
      case 'private_network_create_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.private_network.create.succeeded'));
        storeService.updatePrivateNetwork(payload);
        EventBus.$emit('select-private-network', payload);
        break;
      case 'private_network_create_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.private_network.create.failed'));
        storeService.updatePrivateNetwork(payload);
        break;
      case 'private_network_destroy_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.private_network.destroy.started'));
        storeService.removePrivateNetwork(payload);
        break;
      case 'private_network_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.private_network.destroy.succeeded'));
        storeService.removePrivateNetwork(payload);
        break;
      case 'private_network_destroy_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.private_network.destroy.failed'));
        storeService.removePrivateNetwork(payload);
        break;
      case 'private_network_update_name_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.private_network.changed'));
        storeService.getPrivateNetworks();
        break;
      case 'private_network_update_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.private_network.update.started'));
        storeService.updatePrivateNetwork(payload);
        break;
      case 'private_network_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.private_network.update.succeeded'));
        storeService.updatePrivateNetwork(payload);
        break;
      case 'private_network_update_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.private_network.update.failed'));
        storeService.updatePrivateNetwork(payload);
        break;
      case 'nat_create_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.nat.create.started'));
        storeService.getNats();
        break;
      case 'nat_create_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.nat.create.succeeded'));
        EventBus.$emit('nats-changed');
        storeService.getNats();
        break;
      case 'nat_create_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.nat.create.failed'));
        storeService.getNats();
        break;
      case 'nat_bulk_destroy_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.nat.destroy.started'));
        storeService.removeNats(payload.ids);
        break;
      case 'nat_bulk_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.nat.destroy.succeeded'));
        storeService.removeNats(payload.ids);
        break;
      case 'nat_bulk_destroy_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.nat.destroy.failed'));
        storeService.removeNats(payload.ids);
        break;
      case 'nic_create_started':
        //EventBus.$emit('show-info', this.wsTranslate('ws.nic.create.started'));
        storeService.addNic(payload);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
          storeService.updateMachineNic(payload, 'add');
        }
        break;
      case 'nic_create_succeeded':
        //EventBus.$emit('show-success', this.wsTranslate('ws.nic.create.succeeded'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'nic_create_failed':
        //EventBus.$emit('show-fail', this.wsTranslate('ws.nic.create.failed'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'nic_destroy_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.nic.destroy.started'));
        storeService.removeNic(payload);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
          storeService.updateMachineNic(payload, 'remove');
        }
        break;
      case 'nic_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.nic.destroy.succeeded'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'nic_destroy_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.nic.destroy.failed'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'nic_update_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.nic.update.started'));
        storeService.updateNic(payload);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
          storeService.updateMachineNic(payload, 'update');
        }
        break;
      case 'nic_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.nic.update.succeeded'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'nic_update_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.nic.update.failed'));
        storeService.getNics(true);
        if (payload.virtual_machine) {
          storeService.updateVirtualMachineData(payload.virtual_machine);
        }
        break;
      case 'dm_update_nic_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.nic.update.started'));
        storeService.updateDedicatedNetworks(payload.dm_nic);
        storeService.updateDedicatedNic(payload.dm_nic);
        break;
      case 'dm_update_nic_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.nic.update.succeeded'));
        storeService.updateDedicatedNic(payload.dm_nic);
        break;
      case 'dm_update_nic_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.nic.update.failed'));
        storeService.updateDedicatedNic(payload.dm_nic);
        break;
      // case 'monthly_bandwidth_tracked':
      //   EventBus.$emit('show-info', this.wsTranslate('ws.transferUpdate'));
      //   EventBus.$emit('update-bandwidth', payload);
      //   break;
      case 'audit_log_started':
        // EventBus.$emit('show-info', this.wsTranslate('ws.auditLog.started'));
        EventBus.$emit('update-current-audit-log-page');
        break;
      case 'audit_log_running':
        // EventBus.$emit('show-info', this.wsTranslate('ws.auditLog.started'));
        EventBus.$emit('update-current-audit-log-page');
        break;
      case 'audit_log_succeeded':
        // EventBus.$emit('show-success', this.wsTranslate('ws.auditLog.succeeded'));
        EventBus.$emit('update-current-audit-log-page');
        break;
      case 'audit_log_failed':
        // EventBus.$emit('show-fail', this.wsTranslate('ws.auditLog.failed'));
        EventBus.$emit('update-current-audit-log-page');
        break;

      case 'virtual_machine_hardware_update_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.vm.hardware.started'));
        storeService.updateVirtualMachineHardware(payload);
        if (payload.state) {
          const data: any = { id: payload.id, state: payload.state };
          if (payload.ram) {
            data.ram = payload.ram;
          }
          if (payload.cpu_cores) {
            data.cpu_cores = payload.cpu_cores;
          }
          if (payload.primary_disk && payload.additional_disks) {
            data.storage =
              payload.primary_disk.size +
              payload.additional_disks.reduce((prev: any, item: any) => item.size + prev, 0);
          }
          storeService.updateVirtualMachineData(data);
        }
        break;
      case 'virtual_machine_hardware_update_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.vm.hardware.succeeded'));
        storeService.updateVirtualMachineHardware(payload);
        if (payload.state) {
          storeService.updateVirtualMachineData({ id: payload.id, state: payload.state });
        }
        break;
      case 'virtual_machine_hardware_update_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.vm.hardware.failed'));
        storeService.updateVirtualMachineHardware(payload);
        if (payload.state) {
          storeService.updateVirtualMachineData({ id: payload.id, state: payload.state });
        }
        break;
      case 'region_activate_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.region.activate.started'));
        storeService.updateRegion({ ...payload, ...{ active: true, id: payload.region_id } });
        break;
      case 'region_activate_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.region.activate.succeeded'));
        storeService.updateRegion({ ...payload, ...{ active: true, id: payload.region_id } });
        break;
      case 'region_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.region.destroy.succeeded'));
        storeService.updateRegion({ ...payload, ...{ active: false, id: payload.region_id } });
        (window as any).VueGlobal.$router
          .push(`/workspaces/${payload.workspace_id}/regions/${payload.region_id}`)
          .catch(() => {});
        break;
      case 'region_destroy_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.region.destroy.failed'));
        // TODO: backend should return active state
        storeService.updateRegion({ ...payload, ...{ active: true, id: payload.region_id } });
        (window as any).VueGlobal.$router
          .push(`/workspaces/${payload.workspace_id}/regions/${payload.region_id}`)
          .catch(() => {});
        break;

      case 'region_activate_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.region.activate.failed'));
        // TODO: backend should return active state
        storeService.updateRegion({ ...payload, ...{ active: false, id: payload.region_id } });
        break;
      case 'snapshot_create_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.snapshot.create.started'));
        storeService.addSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_restore_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.snapshot.restore.started'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_restore_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.snapshot.restore.succeeded'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_restore_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.snapshot.restore.failed'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_create_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.snapshot.create.succeeded'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_create_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.snapshot.create.failed'));
        storeService.removeSnapshot(payload.virtual_machine.id);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_destroy_started':
        EventBus.$emit('show-info', this.wsTranslate('ws.snapshot.destroy.started'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_destroy_failed':
        EventBus.$emit('show-fail', this.wsTranslate('ws.snapshot.destroy.failed'));
        storeService.updateSnapshot(payload.virtual_machine.id, payload);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'snapshot_destroy_succeeded':
        EventBus.$emit('show-success', this.wsTranslate('ws.snapshot.destroy.succeeded'));
        storeService.removeSnapshot(payload.virtual_machine.id);
        storeService.updateVirtualMachineData(payload.virtual_machine);
        break;
      case 'workspace_blocked':
        EventBus.$emit('delete-workspace-workspace-blocked', payload);
        storeService.getWorkspaces();
        break;
      case 'workspace_unblocked':
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.workspace_unblocked'));
        storeService.getWorkspaces();
        break;
      case 'workspace_deleted':
        storeService.getWorkspaces().then((data: any) => {
          if (data.workspaces.length) {
            (window as any).VueGlobal.$router.push('/workspace-switch').catch(() => {});
          } else {
            (window as any).VueGlobal.$router.push('/new-workspace').catch(() => {});
          }
        });
        EventBus.$emit('show-info', this.wsTranslate('ws.workspace.workspace_deleted'));
        EventBus.$emit('delete-workspace-success', payload);
        break;
      case 'firewall_create_succeeded':
        EventBus.$emit('show-info', this.wsTranslate('ws.firewallUpdated'));
        EventBus.$emit('firewall_rules_updated');
        break;
      case 'billing_period_repayment_failed':
        EventBus.$emit('billing_period_repayment_failed');
        storeService.updateBillingPeriods(payload);
        break;
      case 'billing_period_repaid':
        EventBus.$emit('billing_period_repaid');
        storeService.updateBillingPeriods(payload);
        break;
      case 'credits_charged':
        EventBus.$emit('credits_charged');
        storeService.updateBillingPeriods(payload);
      case 'virtual_machine_backup_activated':
        EventBus.$emit('backup_activated');
        EventBus.$emit('show-info', this.wsTranslate('ws.backupActivated'));
        storeService.updateVirtualMachineData(payload.virtual_machine);
      case 'virtual_machine_backup_deactivated':
        EventBus.$emit('backup_activated');
        EventBus.$emit('show-info', this.wsTranslate('ws.backupActivated'));
        storeService.updateVirtualMachineData(payload.virtual_machine);
      default:
      // EventBus.$emit('show-snackbar', `Error: Unhandled websocket event "${name}"`);
    }
  }
}

export const websocketService = new WebsocketService();
